import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=5c4393d9&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "./Profile.vue?vue&type=style&index=0&id=5c4393d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4393d9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme4ChangePassword: require('/app/components/Theme4/ChangePassword.vue').default})
